/** 有声书/视频 reader_log：正式阅读与试听分字段，time 共用累计 */

export const MULTIMEDIA_LOG_SAVE_INTERVAL_SEC = 10;

export function parseReaderLogContent(content) {
  if (!content) {
    return {};
  }
  try {
    return typeof content === "string" ? JSON.parse(content) : { ...content };
  } catch {
    return {};
  }
}

export function getFirstPlayableChapterIndex(toc, mediaFilePathKey) {
  if (!toc?.length) {
    return 0;
  }
  const idx = toc.findIndex((chapter) => chapter[mediaFilePathKey]);
  return idx >= 0 ? idx : 0;
}

/**
 * 根据模式从 reader_log 解析应恢复的章节与播放位置
 */
export function getMultimediaLogRestorePosition(readerlog, isPreview, toc, mediaFilePathKey) {
  const firstIdx = getFirstPlayableChapterIndex(toc, mediaFilePathKey);

  if (isPreview) {
    if (readerlog?.previewChapter) {
      return {
        chapterIndex: Math.max(0, readerlog.previewChapter - 1),
        currentTime: readerlog.previewCurrentTime ?? 0,
      };
    }
    return { chapterIndex: firstIdx, currentTime: 0 };
  }

  if (readerlog?.currentChapter) {
    return {
      chapterIndex: Math.max(0, readerlog.currentChapter - 1),
      currentTime: readerlog.currentTime ?? 0,
    };
  }

  return { chapterIndex: firstIdx, currentTime: 0 };
}

/**
 * 合并保存：试听写 preview*，正式写 current*，time 统一累加
 */
export function buildMultimediaLogSaveBody(
  existingLog,
  isPreview,
  { playingTOCIndex, tocLength, currentTime }
) {
  const log = { ...existingLog };
  const chapter = playingTOCIndex + 1;
  const percentage = tocLength > 0 ? chapter / tocLength : 0;

  if (log.time === undefined) {
    log.time = MULTIMEDIA_LOG_SAVE_INTERVAL_SEC;
  } else {
    log.time += MULTIMEDIA_LOG_SAVE_INTERVAL_SEC;
  }

  if (isPreview) {
    log.previewChapter = chapter;
    log.previewCurrentTime = currentTime;
    log.previewPercentage = percentage;
  } else {
    log.currentChapter = chapter;
    log.currentTime = currentTime;
    log.percentage = percentage;
  }

  return log;
}
